import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import tw from 'tailwind.macro';
import Accordion from '../Accordion';
import { CustomH3, HTMLText } from '../SEO';
import { faqsPropTypes } from './constants';

const Text = styled(HTMLText)`
  ${tw`my-def`};
`;

const FAQSection = ({ faqs, open }) =>
  faqs.map((faq) => (
    <Accordion
      key={faq.priority}
      content={
        <Text
          dangerouslySetInnerHTML={{
            __html: faq.answer,
          }}
        />
      }
      header={<CustomH3>{faq.question}</CustomH3>}
      id={`${faq.priority}`}
      open={open || false}
    />
  ));

FAQSection.propTypes = {
  faqs: faqsPropTypes,
  open: PropTypes.bool,
};

export { FAQSection };
